import { ContextMenu, Text } from "../../elements";
import { ArrowDownIcon } from "../../icons";
import { classNames } from "../../support/formatters/class-formatter";
import styles from "./select-dropdown.module.css";

type Item = {
  value: string;
  label: string;
};

export type SelectDropdownProps = {
  items: Item[];
  label?: string;
  icon?: React.ReactNode;
  value?: Item;
  onChange?: (item: Item) => void;
  variant?: "primary" | "secondary";
  theme?: "light" | "dark";
  dataQA?: string;
};

export function SelectDropdown({
  items,
  label,
  icon,
  onChange,
  value,
  variant = "primary",
  theme = "light",
  dataQA,
}: Readonly<SelectDropdownProps>) {
  return (
    <div className={classNames(styles.Container, styles[theme])}>
      {icon && <div className={styles.Svg}>{icon}</div>}
      {label && (
        <span className={styles.Text}>
          <Text>{label}</Text>
        </span>
      )}
      <ContextMenu variant={variant}>
        <ContextMenu.Button>
          <button
            value={value?.value}
            className={styles.ButtonSelector}
            data-testid="select"
            type="button"
            data-qa={dataQA}
          >
            {value?.label}
            <ArrowDownIcon className={styles.Arrow} size={24} />
          </button>
        </ContextMenu.Button>
        <div className={styles.Content}>
          <ContextMenu.Content variant={variant} as="ul" role="menu">
            {items.map((item, index) => (
              <ContextMenu.Item
                key={`${item.value}-${index}`}
                as="li"
                value={item.value}
                onClick={() => onChange?.(item)}
                role="menuitem"
                tabIndex="0"
              >
                {item.label}
              </ContextMenu.Item>
            ))}
          </ContextMenu.Content>
        </div>
      </ContextMenu>
    </div>
  );
}
